module.exports = __webpack_public_path__ + "static/media/background.bbae85a1.jpg";